<!--工单列表查询-->
<template>
  <div class="newsearchOrderList">
    <div class="con">
      <div class="userList-top">
        <div :class="['list-item',{'item-active':item.type == itemActive}]" v-for="(item,index) in orderDefineList"
          :key="index" @click="itemActive = item.type ,nowOrderDefine = item">
          <span :class="['name',{'span-active':item.type == itemActive}]">{{item.name}}</span>
        </div>
      </div>
      <div class="search-input-btn">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small ">
              <span>开始时间：</span>
              <el-date-picker v-model="startTime" type="datetime" clearable placeholder="选择日期时间" align="right"
                :picker-options="pickerOptions"></el-date-picker>
            </div>
            <div class="input-small " style="margin:0px 0.2rem;">
              <span>截止时间：</span>
              <el-date-picker v-model="endTime" type="datetime" clearable placeholder="选择日期时间" align="right"
                :picker-options="pickerOptions"></el-date-picker>
            </div>
            <div class="input-small myinput">
              <span>工单分组：</span>
              <el-select v-model="myvalue1" placeholder="请选择" clearable style="width:1.6rem" @change="orderGroup_fn">
                <el-option v-for="item in $store.orderGroupStore.getters.getOrderGroupTree" :key="item.id"
                  :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput" style="margin:0px 0.2rem;">
              <span>工单状态：</span>
              <el-select v-model="myvalue2" placeholder="请选择" clearable style="width:1.6rem" @change="state_fn">
                <el-option v-for="item in nowStateList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="input-small myinput">
              <span>优先级：</span>
              <el-select v-model="myvalue3" placeholder="请选择" clearable style="width:1.6rem" @change="priority_fn">
                <el-option v-for="item in $store.orderGroupStore.state.priorityList" :key="item.value"
                  :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" size="mini" plain @click="seachOrder" class="search-btn">查询</el-button>
          </div>
        </el-scrollbar>


      </div>
      <div class="mytable">
        <!-- <infoList :style="{height: (openFilter ? 'calc(100% - 0.73rem)':'calc(100% - 2rem)'),width:'100%',transition:'0.3s'}" ref="infoList" @checkItem="nowOrder = $event" :columns='columns'
			 :dataList="nowPage" :pageLen='pageLen' :totalSize="totalSize" @selectPage="selectPage" :fillAll="true">
				<div slot="control" slot-scope="slotProps" v-show="slotProps.item != undefined">
					<span class="intoButton" @click.stop="task_fn(slotProps.item)" style="margin-right:10px;color:#409eff">任务领取</span>
					<span class="intoButton" @click.stop="intoOrder(slotProps.item)" style="color:#409eff">进入</span>
				</div>
				<div slot="delete" slot-scope="slotProps" v-show="slotProps.item != undefined">
					<u class="intoButton" @click.stop="invalidOrder(slotProps.item)" v-show="slotProps.item != undefined && slotProps.item.status != 'Deleted'">作废</u>
					<u class="intoButton" @click.stop="deleteOrder(slotProps.item)" v-show="slotProps.item != undefined && slotProps.item.status == 'Deleted'"
					 style="margin-right: 10px;">删除</u>
					<u class="intoButton" @click.stop="restoreByOrderIds(slotProps.item)" v-show="slotProps.item != undefined && slotProps.item.status == 'Deleted'">恢复</u>
				</div>
			</infoList> -->
        <!-- 前四个 -->
        <el-table :data="tableData" stripe style="width: 100%" :max-height="heights" v-if="isShowTab == 0">
          <template slot="empty">
            <span class="noData">
              <img src="../../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderId" label="单号" width="180"> </el-table-column>

          <el-table-column label="分组" width="120" align="center">
            <template #default="{row}">
              <div class="patrol public-flex" v-if="row.grouping =='巡检'">
                <p></p><span>{{row.grouping}}</span>
              </div>
              <div class="overhaul public-flex" v-if="row.grouping =='检修'">
                <p></p><span>{{row.grouping}}</span>
              </div>
              <div class="rush public-flex" v-if="row.grouping =='抢修'">
                <p></p><span>{{row.grouping}}</span>
              </div>
              <div class="public-flex" v-if="row.grouping =='未分组'">
                <span>{{row.grouping}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="名称" width="180"> </el-table-column>
          <el-table-column prop="creatorName" label="创建人" width="120"> </el-table-column>
          <el-table-column label="状态" width="120" align="center">
            <template #default="{row}">
              <span>{{status_format(row.status)}}</span>
            </template>
          </el-table-column>

          <el-table-column label="优先级" width="120" align="center">
            <template #default="{row}">
              <div class="public-flex">
                <p class="myemergent mutongyong" v-if="row.priority =='紧急'">{{(row.priority)}}</p>
                <p class="myhigh mutongyong" v-if="row.priority =='高'">{{(row.priority)}}</p>
                <p class="mystandard mutongyong" v-if="row.priority =='标准'">{{(row.priority)}}</p>
                <p class="mylow mutongyong" v-if="row.priority =='低'">{{(row.priority)}}</p>
                <p v-if="row.priority =='--'">--</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="180">
            <template #default="{row}">
              <span>{{row.createTime | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="开始时间" width="180">
            <template #default="{row}">
              <span>{{row.startTime | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="截止时间" width="180">
            <template #default="{row}">
              <span>{{(Number(row.startTime) + Number(row.workDay)) | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="最后编辑时间" width="180">
            <template #default="{row}">
              <span>{{row.updateTime | date_format}}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center" width="180" fixed="right">
            <template #default="{row}">
              <span class="buttoned_box" style="display: flex;">
                <p @click="task_fn(row)" style="color:#368ED9;">任务领取</p>
                <span class="line"></span>
                <p @click="intoOrder(row)" style="color:#368ED9;">进入</p>

              </span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 周期工单 -->
        <el-table :data="tableData" stripe style="width: 100%" :max-height="heights" v-if="isShowTab == 1">
          <template slot="empty">
            <span class="noData">
              <img src="../../../assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderId" label="单号" width="220"> </el-table-column>
          <el-table-column label="分组" width="150" align="center">
            <template #default="{row}">
              <div class="patrol public-flex" v-if="row.grouping =='巡检'">
                <p></p><span>{{row.grouping}}</span>
              </div>
              <div class="overhaul public-flex" v-if="row.grouping =='检修'">
                <p></p><span>{{row.grouping}}</span>
              </div>
              <div class="rush public-flex" v-if="row.grouping =='抢修'">
                <p></p><span>{{row.grouping}}</span>
              </div>
              <div class="public-flex" v-if="row.grouping =='未分组'">
                <span>{{row.grouping}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="名称" width="220"> </el-table-column>
          <el-table-column prop="creatorName" label="创建人" width="150"> </el-table-column>

          <el-table-column label="优先级" width="150" align="center">
            <template #default="{row}">
              <div class="public-flex">
                <p class="myemergent mutongyong" v-if="row.priority =='紧急'">{{(row.priority)}}</p>
                <p class="myhigh mutongyong" v-if="row.priority =='高'">{{(row.priority)}}</p>
                <p class="mystandard mutongyong" v-if="row.priority =='标准'">{{(row.priority)}}</p>
                <p class="mylow mutongyong" v-if="row.priority =='低'">{{(row.priority)}}</p>
                <p v-if="row.priority =='--'">--</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="220">
            <template #default="{row}">
              <span>{{row.createTime | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="上次生成时间" width="220">
            <template #default="{row}">
              <span>{{row.startTime | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="下次生成时间">
            <template #default="{row}">
              <span>{{(Number(row.cycleTime) + Number(row.workDay)) | date_format}}</span>
            </template>
          </el-table-column>



        </el-table>

        <!-- 工单模板 -->
        <el-table :data="tableData" stripe style="width: 100%" :max-height="heights" v-if="isShowTab == 2">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderId" label="单号" width="180"> </el-table-column>
          <el-table-column label="分组" width="120" align="center">
            <template #default="{row}">
              <div class="patrol public-flex" v-if="row.grouping =='巡检'">
                <p></p><span>{{row.grouping}}</span>
              </div>
              <div class="overhaul public-flex" v-if="row.grouping =='检修'">
                <p></p><span>{{row.grouping}}</span>
              </div>
              <div class="rush public-flex" v-if="row.grouping =='抢修'">
                <p></p><span>{{row.grouping}}</span>
              </div>
              <div class="public-flex" v-if="row.grouping =='未分组'">
                <span>{{row.grouping}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="名称" width="180"> </el-table-column>
          <el-table-column prop="creatorName" label="创建人" width="120"> </el-table-column>
          <el-table-column label="状态" width="120" align="center">
            <template #default="{row}">
              <div class="mycancel public-flex" v-if="row.status =='Deleted'">
                <p></p><span>作废</span>
              </div>
              <div class="normal public-flex" v-else>
                <p></p><span>正常</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="优先级" width="120" align="center">
            <template #default="{row}">
              <div class="public-flex">
                <p class="myemergent mutongyong" v-if="row.priority =='紧急'">{{(row.priority)}}</p>
                <p class="myhigh mutongyong" v-if="row.priority =='高'">{{(row.priority)}}</p>
                <p class="mystandard mutongyong" v-if="row.priority =='标准'">{{(row.priority)}}</p>
                <p class="mylow mutongyong" v-if="row.priority =='低'">{{(row.priority)}}</p>
                <p v-if="row.priority =='--'">--</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="220">
            <template #default="{row}">
              <span>{{row.createTime | date_format}}</span>
            </template>
          </el-table-column>

          <el-table-column label="最后编辑时间" width="220">
            <template #default="{row}">
              <span>{{row.updateTime | date_format}}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template #default="{row}">
              <span class="buttoned_box" style="display: flex;">
                <p @click="invalidOrder(row)" style="color:#368ED9;" v-if="item.status != 'Deleted'">作废</p>
                <p @click="restoreByOrderIds(row)" style="color:#368ED9;" v-if="item.status == 'Deleted'">恢复</p>
                <span class="line"></span>
                <p @click="deleteOrder(row)" style="color:#FF1D1D;">删除</p>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 任务领取 -->
      <el-dialog v-dialogDrag title="任务领取" :close-on-click-modal='false' :visible.sync="dialogVisible" width="25%"
        center>
        <div class="line" style="width:100%;height:1px;background-color: #e6e6e6"></div>
        <ul class="dialong-ul">
          <li v-for="(item) in tackData" :key="item.id">
            <label><input type="radio" name="radios" :value="item.id" v-model="task"> <span>{{item.nodeName}}</span>
            </label>
          </li>
          <li v-if="tackData.length == 0">任务已被领取</li>
        </ul>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="receiveFun">领 取
            </el-button>
          </span>
        </template>
      </el-dialog>


    </div>



  </div>


</template>

<script>
  import {departmentOrderNode,updateNodeUserId} from "@/api/order";
  export default {
    components: {},
    props: {},
    data () {
      return {
        heights: document.getElementById('app').clientHeight-250,//屏幕高度 - 导航栏高度
        myvalue1: "",
        myvalue2: "",
        myvalue3: "",
        loading: true,
        tableData: [],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '今天',
            onClick (picker) {
              picker.$emit('pick',new Date());
            }
          },{
            text: '昨天',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24);
              picker.$emit('pick',date);
            }
          },{
            text: '一周前',
            onClick (picker) {
              const date=new Date();
              date.setTime(date.getTime()-3600*1000*24*7);
              picker.$emit('pick',date);
            }
          }]
        },
        task: "",
        tackData: [],
        dialogVisible: false,
        orderDefineList: [{
          name: '所有工单',
          type: 'all'
        },{
          name: '周期工单',
          type: 'CycleOrder'
        }],
        nowOrderDefine: undefined,
        nowStatus: undefined,
        nowPriority: undefined,
        nowFilter: {
          orderGroup: false,
          state: false,
          priority: false,
          startTime: false,
          endTime: false
        },
        openFilter: true,
        filterList: [{
          name: '工单分组',
          id: 'orderGroup'
        },{
          name: '工单状态',
          id: 'state'
        },{
          name: '优先级',
          id: 'priority'
        },{
          name: '开始时间',
          id: 'startTime'
        },{
          name: '截止时间',
          id: 'endTime'
        }],
        //当前选中的分组的id数组，单人版本只允许单个
        orderGroupIds: [],
        pageLen: 100,
        nowOrder: [],
        nowIndex: 0,
        orderListByIndex: [], //每一页的记录,修改查询内容后查询就会清空
        startTime: undefined,
        endTime: undefined,
        totalSize: 0,
        userDetailed: "",
        startTimeValue: [],
        newOrderGroupIds: "",
        newstateIds: "",
        newPriorityIds: "",
        itemActive: "all",
        groupArr: [],
        priorityArr: [],
        isShowTab: 0

      }
    },
    created () {},
    mounted () {
      this.groupArr=this.$store.orderGroupStore.getters.getOrderGroupTree
      this.priorityArr=this.$store.orderGroupStore.state.priorityList
      debugPage=this
      this.nowOrderDefine=this.orderDefineList[0]
      // this.$refs.listView.setNowItem(this.orderDefineList[0])
      // this.seachOrder()
      this.userDetailed=JSON.parse(localStorage.getItem('userDetailed'))
    },
    destroyed () {},
    computed: {
      nowPage () {
        var list=this.orderListByIndex[this.nowIndex]
        if(list==undefined) {
          return []
        }
        console.log("list",list);
        return list
      },
      columns () {
        var baseList=[{
          name: '单号',
          key: 'orderId',
          weight: 1.2
        },{
          name: '名称',
          key: 'title',
          weight: 1.4,
        },{
          name: '创建人',
          key: 'creatorName'
        },{
          name: '分组',
          key: 'groupId',
          format: item => {
            return getValueIfNoNull(this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item),{
              name: '未分组'
            }).name
          }
        },{
          name: '优先级',
          key: 'groupId',
          format: item => {
            var group=this.$store.orderGroupStore.getters.getOrderGroupByGroupId(item)
            if(group==undefined) {
              return '--'
            }
            var priority=this.$store.orderGroupStore.getters.getPriorityByValue(group.priority)


            return getValueIfNoNull(priority,{
              name: '--'
            }).name
          }
        },{
          name: '创建时间',
          key: 'createTime',
          format (item) {
            return new Date(item).formatByTime()
          },
          weight: 1.4,
        }]
        if(this.nowOrderDefine==undefined||[undefined,'all','copyToMe','iCreated','myNode'].includes(this.nowOrderDefine
          .type)) {
          baseList.insert(2,{
            name: '状态',
            key: 'status',
            format: item => {
              return this.$store.orderStore.getters.getStateNameByStatus(item)
            }
          })
          baseList.push({
            name: '开始时间',
            key: 'startTime',
            format (item) {
              this.startTimeValue=(item)
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '截止时间',
            key: 'workDay',
            format (item) {
              // console.log("截止时间",baseList[7].startTimeValue + item );
              return new Date(baseList[7].startTimeValue+item).formatByTime()
              // return item
            },
            weight: 1.4,
          })
          baseList.push({
            name: '最后编辑时间',
            key: 'updateTime',
            format (item) {
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '操作',
            type: 'slot',
            key: 'control'
          })
        } else if(this.nowOrderDefine.type=='CycleOrder') {
          baseList.insert(6,{
            name: '上次生成时间',
            key: 'cycleTime',
            format (item) {
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '下次生成时间',
            key: 'cycleTime',
            format (item,data) {
              return new Date(item+data.workDay).formatByTime()
            },
            weight: 1.4,
          })
        } else {
          baseList.insert(2,{
            name: '状态',
            key: 'status',
            format: item => {
              return item=='Deleted'? '作废':'正常'
            }
          })
          baseList.push({
            name: '最后编辑时间',
            key: 'updateTime',
            format (item) {
              return new Date(item).formatByTime()
            },
            weight: 1.4,
          })
          baseList.push({
            name: '操作',
            type: 'slot',
            key: 'delete'
          })
        }
        return baseList
      },
      nowStateList () {
        if(this.nowOrderDefine!=undefined&&this.nowOrderDefine.type=='OrderTemplate') {
          return [{
            name: '正常',
            value: 'NotStarted'
          },{
            name: '作废',
            value: "Deleted"
          }]
        }
        return this.$store.orderStore.state.stateList
      }
    },
    watch: {
      nowOrderDefine (nv,ov) {
        if(nv.name=='周期工单') {
          this.isShowTab=1
        } else if(nv.name=='工单模板') {
          this.isShowTab=2
        } else {
          this.isShowTab=0
        }
        this.seachOrder()
      },
      // task(nv,ov){
      // 	console.log(nv);
      // }
    },
    filters: {
      // 转换时间戳
      "date_format": function(value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    },
    methods: {
      //分组
      group_format (val) {
        console.log("groupArr",this.groupArr);
        var index=this.groupArr.findIndex(item => item.groupId==val)
        if(index==-1) {
          return "未分组"
        } else {
          return this.groupArr[index].name
        }
      },
      //状态
      status_format (val) {
        var index=this.nowStateList.findIndex(item => item.value==val)
        if(index==-1) {
          return ""
        } else {
          return this.nowStateList[index].name
        }
      },
      //优先级
      priority_format (val) {
        var group=this.$store.orderGroupStore.getters.getOrderGroupByGroupId(val)
        if(group==undefined) {
          return '--'
        }
        var index=this.priorityArr.findIndex(item => item.value==group.priority)
        if(index==-1) {
          return "--"
        } else {
          return this.priorityArr[index].name
        }
      },

      //新操作筛选
      //工单分组
      orderGroup_fn (item) {
        this.newOrderGroupIds=item
        this.orderGroupIds=[item]
      },
      //工单状态
      state_fn (item) {
        this.newstateIds=item
        this.nowStatus=item
      },
      //优先级
      priority_fn (item) {
        this.newPriorityIds=item
        this.nowPriority=item
      },
      //操作提醒
      operationFun (types,describe) {this.$message({type: types,message: describe,duration: 1500,offset: 150});},
      receiveFun () {

        updateNodeUserId({"nodeId": this.task,"userId": this.userDetailed.userId}).then(res => {
          // console.log("res",res);
          if(res.code==200) {
            this.operationFun("success","领取成功")
            this.dialogVisible=false
          } else {
            this.operationFun("error","领取失败")
          }
        })
      },
      //任务领取
      task_fn (item) {
        // console.log("点击",item);
        departmentOrderNode({'orderId': item.orderId}).then(res => {
          // console.log("任务",res);
          if(res.code==200) {
            this.tackData=res.data
          }
        })
        this.dialogVisible=true
      },

      selectPage (index) {
        this.nowIndex=index
        if(isempty(this.nowPage)) {
          this.seachOrder()
        }
      },
      seachOrder () {
        //个人版只能查询部分内容
        //判断参与人类型
        var myId=this.$store.userStore.state.nowUserInfo.id
        var creatorIds=undefined
        var nodeUsers=undefined
        var participants=undefined
        switch(this.nowOrderDefine.type) {
          case 'all':
            break
          case 'copyToMe':
            participants=myId
            break
          case 'iCreated':
            creatorIds=myId
            break
          case 'myNode':
            nodeUsers=myId
            break
        }
        //排除多余的检查项
        var orderGroupIds=undefined
        if(this.orderGroupIds.length!=0) {
          orderGroupIds=this.orderGroupIds.join(',')
        }
        var nowStatus=undefined
        if(this.newstateIds) {
          nowStatus=this.newstateIds
        }
        var nowPriority=undefined
        if(this.newPriorityIds) {
          nowPriority=this.newPriorityIds
        }
        var startTime=undefined
        if(this.startTime) {
          startTime=this.startTime.getTime()
        }
        var endTime=undefined
        if(this.endTime) {
          endTime=this.endTime.getTime()
        }
        //判断工单类型
        var orderType='Order'
        if(this.nowOrderDefine!=undefined&&['CycleOrder','OrderTemplate'].includes(this.nowOrderDefine.type)) {
          orderType=this.nowOrderDefine.type
          creatorIds=myId
        }
        this.loading=true

        this.$api.orderApi.searchByTypes(this.nowIndex+1,this.pageLen,orderGroupIds,orderType,nowStatus,nowPriority,
          creatorIds,nodeUsers,participants,startTime,endTime,undefined,respon => {
            this.totalSize=respon.total
            this.tableData=respon.dataList
            this.tableData.forEach(item => {
              item.grouping=this.group_format(item.groupId)
              item.priority=this.priority_format(item.groupId)
            })
            this.loading=false
            this.$set(this.orderListByIndex,this.nowIndex,respon.dataList)
            if(orderType=='OrderTemplate') {
              this.$store.orderStore.commit('getOrderTemplateList')
            }
          },err => {
            this.loading=false
            this.$message({
              type: 'error',
              message: err
            });
          })
      },
      intoOrder (order) {
        //进入工单
        this.$store.orderStore.commit('setNowOrder',order)
        this.$router.push('/dealOrder')
      },
      invalidOrder (order) {
        this.$api.orderApi.removeByOrderIds(order.orderId,'用户 '+this.$store.userStore.state.nowUserInfo.username+
          ' 将其置为作废',respon => {
            order.status='Deleted'
            order.updateTime=new Date().formatByTime()
            var list=this.orderListByIndex[this.nowIndex]
            this.$set(list,list.findIndex(item => {
              return item.orderId==order.orderId
            }),order)
            this.$dialogMethod.showMessage('作废成功!')
            this.$store.orderStore.commit('getOrderTemplateList')
          })
      },
      deleteOrder (order) {
        this.$api.orderApi.deleteByOrderIds(order.orderId,respon => {
          var list=this.orderListByIndex[this.nowIndex]
          this.$set(this.orderListByIndex,this.nowIndex,list.filter(item => {
            return item.orderId!=order.orderId
          }))
          this.$dialogMethod.showMessage('删除成功!')
        })
      },
      restoreByOrderIds (order) {
        this.$api.orderApi.restoreByOrderIds(order.orderId,respon => {
          order.status='NotStarted'
          var list=this.orderListByIndex[this.nowIndex]
          this.$set(list,list.findIndex(item => {
            return item.orderId==order.orderId
          }),order)
          this.$dialogMethod.showMessage('恢复成功!')
          this.$store.orderStore.commit('getOrderTemplateList')
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .search-input-btn {
    width: 100%;
    height: 36px;

    .my-search-i {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }

  .public-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }


  // 巡检
  .patrol {
    p {
      width: 8px;
      height: 8px;
      background-color: #0DAE88;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      color: #0DAE88;
    }
  }

  // 检修
  .overhaul {
    p {
      width: 8px;
      height: 8px;
      background-color: #FF9900;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      color: #FF9900;
    }
  }

  // 抢修
  .rush {
    p {
      width: 8px;
      height: 8px;
      background-color: #FD602E;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      color: #FD602E;
    }
  }

  .mutongyong {
    width: 36px;
    height: 22px;
    text-align: center;
    line-height: 22px;
  }

  //紧急
  .myemergent {
    color: #FF1D1D;
    background-color: #FFE7E7;
  }

  //高
  .myhigh {
    color: #BF458E;
    background-color: #FFE9F6;
  }

  //标准
  .mystandard {
    color: #5452C9;
    background-color: #E5E8FF;
  }

  //低
  .mylow {
    color: #2981D2;
    background-color: #DEF3FF;
  }

  //作废
  .mycancel {

    p {
      width: 8px;
      height: 8px;
      background-color: #cccccc;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      color: #999999;
    }
  }

  //正常
  .normal {
    p {
      width: 8px;
      height: 8px;
      background-color: #368ED9;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      color: #368ED9;
    }
  }


  /deep/.el-scrollbar__wrap {
    overflow-x: hidden;
  }

  /deep/.el-scrollbar__view {
    width: 100% !important;
  }

  .con {
    width: 100%;
    height: 100%;
    padding: 12px 20px 20px 20px;
    background-color: #fff;
    box-sizing: border-box;
  }

  .userList-top {
    display: flex;
    height: 37px;
    border-bottom: 2px solid #e6e6e6;

    .list-item {
      margin-right: 40px;
    }

    span {
      font-size: 16px;
      color: #666666;
      display: inline-block;
      height: 100%;

      &.span-active {
        color: #368ED9;
        border-bottom: 2px solid #368ED9;
      }
    }
  }

  .buttoned_box {
    display: flex;
    // justify-content: space-around;
    justify-content: center;
    align-items: center;

    .line {
      display: inline-block;
      width: 1px;
      height: 20px;
      background-color: #E6E6E6;
      margin: 0px 12px;
    }

    p {
      font-size: 14px;
      cursor: pointer;
    }


  }

  .right {
    width: calc(100% - 2rem);
    // width:calc(100% - .12rem);
    padding-top: .2rem;
    padding-left: 0.2rem;

    .search-top {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .screen {
        margin: 0px 20px;
        cursor: pointer;

        i {
          transition: 0.3s;

          &.tran-i {
            transform: rotateZ(180deg);
          }
        }
      }
    }

    .screen-con {
      width: 100%;
      height: 1.3rem;
      transition: 0.3s;
      overflow: hidden;

      &.active-top {
        height: 0px;
      }

      .screen-item {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .item-title {
          color: #999999;
          margin-right: 3px;
          text-align: right;
          width: 70px;
        }

        .con {
          cursor: pointer;
          color: #1A1A1A;
          padding: 4px 8px;

          i {
            font-size: 14px;
            margin-left: 3px;
            color: #FFFFFF;
          }

          &.active {
            background-color: #409EFF;
            color: #FFFFFF;
            border-radius: 5px;
          }
        }

      }
    }

    .right-table {
      height: 100%;
      // width: 100%;
      // height: 500px;
      // background-color: red;
    }

    /deep/.el-input__inner {
      height: .34rem !important;
      line-height: .34rem !important;
    }

    /deep/.el-input__icon {
      line-height: .34rem !important;
    }
  }

  .marginLeft {
    margin: 0 10px;
  }

  .intoButton {
    color: #DA7800;
    text-align: center;
    cursor: pointer;
  }

  /deep/.el-dialog__title {
    color: #52a1ff;
    font-weight: bold;
  }

  /deep/.el-dialog__body {
    padding: 0px;
  }

  .filterDiv {
    background: white;
    width: calc(100% - 20px);
    padding: 0 10px;
  }

  .filterDiv>div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    border-bottom: silver 1px dashed;
  }

  .dialong-ul {
    overflow: hidden;

    li {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      padding-left: 75px;
      // margin-top: 10px;
      border-bottom: 1px solid #e6e6e6;
      cursor: pointer;

      &.active {
        background-color: #f5f0dd;
      }

      span {
        margin-left: 10px;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }

  .filterDiv>div>p {
    font-size: .12rem;
    padding: 2px 5px;
    cursor: pointer;
    margin: 5px 10px;
    border-radius: 10px;
  }

  .filterDiv>div>p.isCheck {
    color: white;
    background: #DA7800;
  }

  .filterDiv>div>span {
    font-size: .12rem;
    padding: 5px 10px;
    color: #7f7f7f;
    min-width: 60px;
  }

  .filterDiv>>>.wedoButton-body {
    background: silver;
  }
</style>